import { Modal, Text, Group, Button, Stack, ModalProps } from '@mantine/core';
import { ReactNode } from 'react';

interface ConfirmDialogProps
  extends Omit<ModalProps, 'opened' | 'onClose' | 'title' | 'children'> {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  titleIcon?: ReactNode;
}

export default function ConfirmDialog({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading = false,
  titleIcon,
  ...modalProps
}: ConfirmDialogProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          {titleIcon}
          <Text fw={600} size="lg">
            {title}
          </Text>
        </Group>
      }
      size="md"
      centered
      withCloseButton
      styles={{
        header: {
          borderBottom: '1px solid var(--mantine-color-gray-3)',
          paddingBottom: 'var(--mantine-spacing-md)',
        },
        body: {
          padding: 'var(--mantine-spacing-lg)',
        },
      }}
      {...modalProps}
    >
      <Stack gap="lg">
        <Text size="lg" fw={500} ta="center">
          Are you sure?
        </Text>
        <Text size="md" ta="center">
          {message}
        </Text>

        <Group justify="center" gap="md" mt="md">
          <Button
            variant="light"
            onClick={onClose}
            disabled={loading}
            size="md"
            style={{ minWidth: '120px' }}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            loading={loading}
            size="md"
            style={{ minWidth: '120px' }}
          >
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
